import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, NgModel, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule, registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';

import { AppRoutingModule } from '@/app-routing.module';
import { AppComponent } from './app.component';

import { Interceptor } from './helpers';
import { MainComponent } from '@modules/main/main.component';
import { LoginComponent } from '@modules/login/login.component';
import { MenuSidebarComponent } from '@modules/main/menu-sidebar/menu-sidebar.component';

import { ForgotPasswordComponent } from '@modules/forgot-password/forgot-password.component';
import { RecoverPasswordComponent } from '@modules/recover-password/recover-password.component';
import { HeaderComponent } from './modules/main/header/header.component';
import { DashboardComponent } from '@pages/dashboard/dashboard.component';
import { InventoryModule } from '@pages/inventory/inventory.module';
import { MediaManagementComponent } from '@pages/media-management/media-management.component';

import { ToastrModule } from 'ngx-toastr';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';

import { OverlayscrollbarsModule } from 'overlayscrollbars-ngx';
import { ChartsModule } from 'ng2-charts';
import { NgDynamicBreadcrumbModule } from 'ng-dynamic-breadcrumb';
import { ModalModule } from 'ngx-bootstrap/modal';
import { LaddaModule } from 'angular2-ladda';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { NetworkInterceptor } from './network.interceptor';
import { LoaderComponent } from '@components/loader/loader/loader.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { NgxPaginationModule } from 'ngx-pagination';
import { AuctionCarinfoComponent } from './pages/auction-carinfo/auction-carinfo.component';
import { AuctionCarListComponent } from './pages/auction-car-list/auction-car-list.component';
import { ComponentsModule } from '@components/components.module';
import {
  RemoveUnderscorePipe,
  ReportsComponent,
} from './pages/reports/reports.component';
import { CustomerRequestComponent } from './pages/customer-request/customer-request.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { IonicModule } from '@ionic/angular';
import { DataTablesModule } from 'angular-datatables';
import { PurchaseDetailsComponent } from './pages/purchase-details/purchase-details.component';
import { SwiperModule } from 'swiper/angular';
import { AutozakiLogoComponent } from './shared/components/autozaki-logo/autozaki-logo.component';

registerLocaleData(localeEn, 'en-EN');

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    LoginComponent,
    MenuSidebarComponent,
    DashboardComponent,
    ForgotPasswordComponent,
    RecoverPasswordComponent,
    HeaderComponent,
    MediaManagementComponent,
    AuctionCarinfoComponent,
    AuctionCarListComponent,
    ReportsComponent,
    CustomerRequestComponent,
    RemoveUnderscorePipe,
    PurchaseDetailsComponent,
    AutozakiLogoComponent,
  ],
  imports: [
    DataTablesModule,
    ComponentsModule,
    CommonModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    OverlayscrollbarsModule,
    ChartsModule,
    NgDynamicBreadcrumbModule,
    NgxMaterialTimepickerModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    BsDropdownModule.forRoot(),
    TabsModule,
    CollapseModule.forRoot(),
    ModalModule.forRoot(),
    BsDatepickerModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    SweetAlert2Module.forRoot(),
    TypeaheadModule.forRoot(),
    TooltipModule.forRoot(),
    NgSelectModule,
    FormsModule,
    MatProgressBarModule,
    ToastrModule.forRoot({
      timeOut: 2000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
    }),
    LaddaModule.forRoot({
      style: 'contract',
      spinnerSize: 40,
      spinnerColor: '#F9B22C',
      spinnerLines: 12,
    }),
    InventoryModule,
    NgxPaginationModule,
    IonicModule.forRoot(),
    SwiperModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
